/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon64Regular = forwardRef('KonturBonusSignIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33 3a1.5 1.5 0 0 0-3 0v8H18.5a4.5 4.5 0 0 0-4.5 4.5v33a4.5 4.5 0 0 0 4.5 4.5H30v8a1.5 1.5 0 0 0 3 0v-8h5c6.627 0 12-5.373 12-12s-5.373-12-12-12H17V15.5a1.5 1.5 0 0 1 1.5-1.5h26a1.5 1.5 0 0 0 0-3H33V3ZM17 48.5V32h21a9 9 0 1 1 0 18H18.5a1.5 1.5 0 0 1-1.5-1.5Z" })));
});
